import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useCurrency } from '@/contexts/currency';
import { CURRENCIES, getAvailableCurrencies } from '@/config/pricing';
import { CurrencyCode } from '@/types/billing/currency';

interface CurrencySelectorProps {
  size?: 'default' | 'lg';
}

const CurrencySelector = ({ size = 'default' }: CurrencySelectorProps) => {
  const { currency, setCurrency } = useCurrency();
  const availableCurrencies = getAvailableCurrencies();

  const sizeClasses = size === 'lg'
    ? 'w-[200px] h-11 text-base'
    : 'w-[160px] h-9 text-sm';

  return (
    <Select
      value={currency}
      onValueChange={(value) => setCurrency(value as CurrencyCode)}
    >
      <SelectTrigger className={`${sizeClasses} bg-white border-gray-200`}>
        <SelectValue>
          <span className="flex items-center gap-2">
            <span className="font-medium">{CURRENCIES[currency].symbol}</span>
            <span>{currency}</span>
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {availableCurrencies.map((code) => {
          const config = CURRENCIES[code];
          return (
            <SelectItem key={code} value={code}>
              <span className="flex items-center gap-2">
                <span className="font-medium w-4">{config.symbol}</span>
                <span>{code}</span>
                <span className="text-muted-foreground">- {config.name}</span>
              </span>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
};

export default CurrencySelector;
